var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('svg', {
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "width": "27",
      "height": "28",
      "viewBox": "0 0 27 28",
      "fill": "none"
    }
  }, [_c('path', {
    attrs: {
      "d": "M13.3023 26.8204C20.3167 26.8204 26.003 21.1341 26.003 14.1197C26.003 7.10531 20.3167 1.41901 13.3023 1.41901C6.2879 1.41901 0.601593 7.10531 0.601593 14.1197C0.601593 21.1341 6.2879 26.8204 13.3023 26.8204Z",
      "fill": "#36F8A3",
      "stroke": "#36F8A3"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M8.42172 14.7298L12.0819 18.39L18.1823 11.0696",
      "fill": "#36F8A3"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M8.42172 14.7298L12.0819 18.39L18.1823 11.0696",
      "stroke": "white",
      "stroke-width": "1.95452",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  })]);
};
var staticRenderFns = [];
export { render, staticRenderFns };